module.exports = __webpack_public_path__ + "static/media/PE.d57d5002.svg";